/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdescriptionwillappearhere4Inputs */

const en_eventdescriptionwillappearhere4 = /** @type {(inputs: Eventdescriptionwillappearhere4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event description will appear here...`)
};

const de_eventdescriptionwillappearhere4 = /** @type {(inputs: Eventdescriptionwillappearhere4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Eventbeschreibung steht dann hier…`)
};

/**
* | output |
* | --- |
* | "Event description will appear here..." |
*
* @param {Eventdescriptionwillappearhere4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdescriptionwillappearhere4 = /** @type {((inputs?: Eventdescriptionwillappearhere4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdescriptionwillappearhere4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdescriptionwillappearhere4(inputs)
	return de_eventdescriptionwillappearhere4(inputs)
});
export { eventdescriptionwillappearhere4 as "eventDescriptionWillAppearHere" }